import { l } from '@manychat/manyui'

export const getWaIdTooltipText = () => `html#
${l.translate(
  'By enabling, you confirm consent to receive WhatsApp messages and compliance with<l10n context="WhatsApp Business Policy and Manychat\'s Terms"/>',
)}
<a class="text-underline" rel="noreferrer" href="https://www.whatsapp.com/legal/business-policy" target="_blank">${l.translate(
  '<l10n context="By enabling, you confirm consent to receive WhatsApp messages and compliance with"/>WhatsApp Business Policy<l10n context="and Manychat\'s Terms"/>',
)}</a>
${l.translate('and')}
<a class="text-underline" rel="noreferrer" href="https://www.whatsapp.com/legal/business-policy" target="_blank">${l.translate(
  '<l10n context="By enabling, you confirm consent to receive WhatsApp messages and compliance with WhatsApp Business Policy and"/>Manychat\'s Terms',
)}</a>.
`
